import NoAccessRoute from '@routes/NoAccessRoute.tsx'
import { type SystemRole, useUser } from '@state/user'

import GuardLoadingScreen from './GuardLoadingScreen'

import type { PropsWithChildren, ReactNode } from 'react'

interface RoleGuardProps extends PropsWithChildren {
    allowedRoles: SystemRole[]
    fallback?: ReactNode
}

/**
 * Generic role-based guard. While user is loading shows loading screen.
 * If the user role is not included in allowedRoles renders the provided fallback (403 semantics).
 * Otherwise, renders children.
 */
function SystemRoleGuard({ allowedRoles, fallback, children }: RoleGuardProps) {
  const { data: user, isLoading } = useUser()

  if (isLoading) return <GuardLoadingScreen />
  if (!user) return null // should not happen, as useUser would be in error state

  if (!allowedRoles.includes(user.role)) {
    if (fallback) return fallback
    return <NoAccessRoute />
  }

  return children
}

export default SystemRoleGuard